export enum SIMULATION_STATUSES {
  AWAITING_UW_DECISION = 'AWAITING_UW_DECISION',
  AWAITING_OFFERS_DECISION = 'AWAITING_OFFERS_DECISION',
  AWAITING_KYC_DECISION = 'AWAITING_KYC_DECISION',
  AWAITING_CONTRACT_SIGNING = 'AWAITING_CONTRACT_SIGNING',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
  APPLICATION_IN_PROGRESS = 'APPLICATION_IN_PROGRESS',
  AWAITING_ADDITIONAL_INFO = 'AWAITING_ADDITIONAL_INFO',
  KYC_IN_PROGRESS = 'KYC_IN_PROGRESS',
  AWAITING_ADDITIONAL_KYC_INFO = 'AWAITING_ADDITIONAL_KYC_INFO',
  CLOSED = 'CLOSED',
}
